import CustomInput from 'src/componentes/CustomInput';

function Checkbox({ type = 'switch', ...rest }) {
  return <CustomInput type={type} {...rest} />;
}

export default Checkbox;
